export default __webpack_public_path__ + "static/media/smi.7d81ccad.svg";